<template>
    <div class="bannerWrapper">
        <img 
            class="logoSmall"
            :src="require('../../assets/vegotarLong.png')" 
            alt=""
        >
        <div class="backgroundImageSlot"></div>
        <img 
            class="backgroundImgOne"
            :src="require('../../assets/shopLanding/backgroundImage.png')" 
            alt=""
        >
      <div class="flex-sides">
        <div class="bannerTitle">
          <div class="smallTitle">
            {{ $t('banner.smallTitle', currentLang) }}
          </div>
          <h1>
            {{ $t('banner.title', currentLang) }} <br>
            <span class="rollTitle" style="color: steelblue">{{ currentWords }}</span><div class="caret" v-if="showCaret"></div>
          </h1>
          <p v-html="$t('banner.text', currentLang)"></p>
          <div class="btns">
              <Button 
                style="height: 60px; font-family: 'Space Grotesk', Sans-serif;font-size: 16px;font-weight: 500; letter-spacing: 0.5;padding-left: 15px; padding-right: 15px; background-color: steelblue; border: 1px solid steelblue;" 
                :label="$t('buttons.contactUsLong', currentLang)" 
                @click="$emit('openContactPopup')" 
                icon="pi pi-phone" 
                severity="contrast" 
              />
              <Button 
                style="height: 60px; border-color: steelblue;font-family: 'Space Grotesk', Sans-serif; font-size: 16px;font-weight: 500; letter-spacing: 0.5;padding-left: 15px; padding-right: 15px; border: 1px solid steelblue; color: steelblue" 
                :label="$t('buttons.shopLong', currentLang)" 
                @click="$router.push({ name: 'catalogPage' })" 
                icon="pi pi-lightbulb" 
                outlined 
                severity="contrast" 
              />
          </div>
        </div>
  
        <div class="imageSection">
            <div class="imageContainer">
                <img 
                    :src="require('../../assets/shopLanding/banner/bannerImage1.jpg')" 
                    alt=""
                >
            </div>
            <div class="imageContainer" id="imageContainerDown">
                <img 
                    :src="require('../../assets/shopLanding/banner/bannerImage2.jpg')" 
                    alt=""
                >
            </div>
            <div class="imageContainer" id="imageContainerUp">
                <img 
                    :src="require('../../assets/shopLanding/banner/bannerImage3.jpg')" 
                    alt=""
                >
            </div>
            <div class="imageContainer">
                <img 
                    :src="require('../../assets/shopLanding/banner/bannerImage4.jpg')" 
                    alt=""
                >
            </div>
            
        </div>
      </div>
    </div>
</template>

<script>
import Button from 'primevue/button';

export default {
  name: 'mainBanner',
  components: {
    Button
  },
  props: {
    shopData: null,
  },
  computed: {
    currentLang() {
        return this.$route.params.lang || 'et';
    },
    words() {
        return this.$t('banner.changingTitle', this.currentLang);
    },
  },
  data() {
    return {
      currentWords: "",
      isDeleting: false,
      wordIndex: 0,
      charIndex: 0,
      cycleDelay: 2000,
      typingInterval: null,
      showCaret: true
    };
  },
  mounted() {
        setTimeout(() => {
            this.startTypingEffect();
        }, 1000);
    },
    methods: {
        startTypingEffect() {
        if (this.typingInterval) clearTimeout(this.typingInterval);

        const speed = this.isDeleting ? 40 : 50;
        const fullWord = this.words[this.wordIndex];
        const isLastWord = this.wordIndex === this.words.length - 1;

        if (!this.isDeleting && this.charIndex < fullWord.length) {
            this.currentWords = fullWord.substring(0, this.charIndex + 1);
            this.charIndex++;
        } else if (this.isDeleting && this.charIndex > 0) {
            this.currentWords = fullWord.substring(0, this.charIndex - 1);
            this.charIndex--;
        }

        if (!this.isDeleting && this.charIndex === fullWord.length) {
            // If it's the last word, don't start deleting
            if (isLastWord) {
                this.showCaret = false;
                return;
            }
            this.isDeleting = true;
            this.cycleDelay = Math.min(this.cycleDelay * 1.05, 45000);
            this.typingInterval = setTimeout(this.startTypingEffect, this.cycleDelay);
        } else if (this.isDeleting && this.charIndex === 0) {
            this.isDeleting = false;
            this.wordIndex = (this.wordIndex + 1) % this.words.length;
            this.typingInterval = setTimeout(this.startTypingEffect, speed);
        } else {
            this.typingInterval = setTimeout(this.startTypingEffect, speed);
        }
    },
  },
  beforeUnmount() {
    if (this.typingInterval) clearTimeout(this.typingInterval); // Clean up interval
  }
};
</script>

  
<style scoped>
.bannerWrapper {
    position: relative;
    z-index: 1049;
    width: 100%;
    background: #EFF1F3;
    padding: 150px 0px 80px 0px;
    background-image: url("https://metla.peerduck.com/wp-content/uploads/2023/09/3y5n5.png");
    background-position: top left;
    background-position-y: 105px;
    background-repeat: no-repeat;
    background-size: 25.5% auto;
}
.backgroundImgOne {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 23%;
    opacity: 0.35;
}
.flex-sides {
    position: relative;
    width: 1300px;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}
.bannerTitle {
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    margin-top: auto;
    margin-bottom: auto;
    margin-top: 0px;
    font-size: 15px;
    padding-right: 35px;
    width: 47%;
}
.coverImg {
    margin-top: 0px;
    margin-bottom: -10px;
    width: 250px;
    opacity: 1;
}
.bannerTitle h1 {
    color: #45657d;
    font-size: 64px;
    line-height: 1.1em;
    font-weight: 600;
    letter-spacing: -1.7px;
    margin: 0;
    margin-top: 20px;
    margin-bottom: 20px;
}
.bannerTitle p {
    color: #3a5a75;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.7em;
    margin-bottom: 50px;
    margin-top: 40px;
}
.smallTitle {
    color: rgba(70, 131, 180, 0.9);
    font-family: "Space Grotesk", Sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.3em;
    letter-spacing: 0px;
}
.organic {
    position: absolute;
    right: 100px;
    top: 50px;
}
.discountOffer {
    position: absolute;
    z-index: 2;
    top: 140px;
    right: 60px;
}
.offer {
    position: absolute;
    top: 2px;
    left: 28px;
}
.offer h3 {
    color: white;
    font-family: 'Satoshi-Bold';
    font-size: 30px;
    margin-bottom: 0;
    -webkit-transform: rotate(6.193deg);
        -ms-transform: rotate(6.193deg);
            transform: rotate(6.193deg);
}
.offer span {
    -webkit-transform: rotate(6.193deg);
        -ms-transform: rotate(6.193deg);
            transform: rotate(6.193deg);
    color: white;
    font-family: 'Satoshi-Medium';
    font-size: 20px;
    display: inline-block;
    margin-left: -1px;
    margin-top: -10px;
}
.caret {
  display: inline-block;
  width: 1px;
  height: 32px;
  -webkit-animation: blink 0.8s infinite;
          animation: blink 0.8s infinite;
  margin-left: 5px;
  background: rgb(65, 65, 65);
}
.rollTitle {
  font-size: 2.2rem;
}
.imageSection {
    margin-top: -35px;
    width: 51.3%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between
}
/* .imageSection img {
    width: 318px;
    height: 300px;
} */
.imageContainer {
    position: relative;
    width: 318px;
    height: 300px;
    overflow: hidden;
}
.imageContainer img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  -webkit-clip-path: polygon(0 0, 83% 0, 100% 24%, 100% 100%, 0 100%);
          clip-path: polygon(0 0, 83% 0, 100% 24%, 100% 100%, 0 100%);
}
.btns button:first-child {
    margin-right: 25px;
}
#imageContainerUp {
    margin-top: -70px;
}
#imageContainerDown {
    margin-top: 70px; 
    margin-bottom: 30px;
}
.logoSmall {
    display: none;
}
@media(max-width: 1340px) {
    .flex-sides {
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
        flex-wrap: wrap;
    }
    /* .imageSection {
        width: 100%;
    } */
    .imageContainer {
        width: 49%;
    }
    .logoSmall {
        margin-top: -100px;
        margin-left: 20px;
        margin-bottom: 20px;
        display: initial;
    }
}
@media(max-width: 1100px) {
    .bannerTitle {
        margin-top: 50px;
    }
    .imageSection {
        order: 0;
        width: 100%;
    }
    .bannerTitle {
        order: 1;
        width: 100%;
    }
    .imageContainer {
        width: 49%;
    }
    .bannerWrapper {
        padding: 70px 0px 80px 0px;
    }
    .logoSmall {
        margin-top: -35px;
        margin-left: 20px;
        margin-bottom: 55px;
        display: initial;
    }
}
@media(max-width: 600px) {
    .bannerWrapper {
        padding: 40px 0px 80px 0px;
    }
    .bannerTitle {
        margin-top: 35px;
        text-align: center;
        padding: 0;
    }
    .imageContainer {
        width: 48%;
        height: 240px;
    }
    .bannerTitle h1 {
        font-size: 15vw;
    }
    
}
@media(max-width: 500px) {
    .btns {
        display: flex;
    }
    .bannerWrapper {
        padding-bottom: 50px;
    }
}
@media(max-width: 450px) {
    .imageContainer {
        width: 48%;
        height: 200px;
    }
    .imageSection {display: none;}
    .bannerTitle h1 {
        margin-top: 10px;
        margin-bottom: 0px;
    }
    .bannerTitle p {
        font-size: 16px;
        margin-bottom: 30px;
        margin-top: 30px;
    }
    .btns button:first-child {
        margin-right: 15px;
    }
    #imageContainerUp {
        margin-top: -40px;
    }
    #imageContainerDown {
        margin-top: 40px; 
        margin-bottom: 20px;
    }
    .logoSmall {
        margin-left: 0;
        margin-right: 0;
        margin: auto;
        margin-top: -45px;
        margin-bottom: 0;
        width: 100%;
        padding-right: 20px;
        padding-left: 20px;
        display: none;
    }
    .bannerTitle {
        margin-top: 0px;
    }
}
@media(max-width: 390px) {
    .imageContainer {
        width: 48%;
        height: 170px;
    }
    
}
</style>